<template>
    <div class="inPage">
        <BannerIn :bannerUrl="bannerUrl" :positionInfo="positionInfo" />
        <router-view></router-view>
    </div>
</template>

<script>
import BannerIn from '../../components/BannerIn/BannerIn'
import { getListPage,getSort } from '../../api'

export default {
    components:{
        BannerIn,
    },
    data(){
        return{
            bannerUrl:'' ,
            positionInfo:{
                second:'News',
                third:''
            },
            
            isZhong:false,
            total:0,
            pageList:[]
        }
    },
    async created(){
        const language = this.$cookies.get('language');
        let isZhong;
        if(language==="zhong"){
            isZhong = true;
        }else{
            isZhong = false;
        }
        this.isZhong = isZhong;

        let positionInfo = {};
    
        if(isZhong){
            positionInfo={
                second:'新闻中心',
                third:''
            }
        }else{
            positionInfo={
                second:'News',
                third:''
            }
        }
        this.positionInfo = positionInfo;

      

       //更新bannerIn
       const res = await getSort(2);
       this.bannerUrl = res.data.pic;

      

    }
   
};
</script>

<style lang="scss" scoped>
@import '../../common/css/mixin.scss';

</style>


// WEBPACK FOOTER //
// src/pages/News/News.vue